import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Megaphone } from "lucide-react";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { Switch } from "./ui/switch";

const LEVELS = [
  ["info", "Info", "bg-blue-500"],
  ["warning", "Attenzione", "bg-amber-500"],
  ["urgent", "Urgente", "bg-red-500"],
];

export default function GlobalNoticeEditor() {
  const [n, setN] = useState({ enabled: false, text: "", level: "info" });
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    api.get("/billing/config").then((r) => setN({ enabled: false, text: "", level: "info", ...(r.data.global_notice || {}) })).catch(() => {});
  }, []);
  const save = async () => {
    if (n.enabled && !n.text.trim()) return toast.error("Scrivi il testo del messaggio");
    setSaving(true);
    try { await api.put("/super-admin/billing", { global_notice: n }); toast.success("Banner avviso globale salvato"); }
    catch (e) { toast.error("Salvataggio non riuscito"); }
    setSaving(false);
  };
  return (
    <div data-testid="global-notice-editor" className="bg-card border border-slate-200/80 rounded-xl shadow-sm p-5 mb-8">
      <div className="flex items-center justify-between gap-3 mb-3">
        <p className="font-semibold text-slate-900 flex items-center gap-2"><Megaphone style={{ width: 17, height: 17 }} className="text-primary" /> Banner Avviso Globale</p>
        <label className="flex items-center gap-2 text-sm text-slate-600">
          <Switch data-testid="global-notice-enabled" checked={!!n.enabled} onCheckedChange={(v) => setN((s) => ({ ...s, enabled: v }))} /> Attivo
        </label>
      </div>
      <Textarea data-testid="global-notice-input" rows={2} value={n.text} onChange={(e) => setN((s) => ({ ...s, text: e.target.value }))}
        placeholder="Es. Manutenzione programmata domenica dalle 22:00 alle 23:00" />
      <div className="flex items-center justify-between gap-3 mt-3 flex-wrap">
        <div className="flex gap-2">
          {LEVELS.map(([v, l, dot]) => (
            <button key={v} type="button" data-testid={`global-notice-level-${v}`} onClick={() => setN((s) => ({ ...s, level: v }))}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-xs font-semibold ${n.level === v ? "border-slate-900 text-slate-900" : "border-slate-200 text-slate-500"}`}>
              <span className={`w-2 h-2 rounded-full ${dot}`} /> {l}
            </button>
          ))}
        </div>
        <Button data-testid="global-notice-save" onClick={save} disabled={saving} className="font-semibold">Salva banner</Button>
      </div>
      <p className="text-xs text-slate-400 mt-2">Mostrato in alto a tutti gli utenti loggati. Ogni nuovo salvataggio lo fa ricomparire anche a chi l'aveva chiuso.</p>
    </div>
  );
}
